/**
 * A single ref-counted lock on page scroll.
 *
 * Several overlays hide body scroll while they are up: the modals and the
 * "Updating your deliveries" mutation spinner. When two overlap, for example
 * the Stop dialog is open and its submit raises the spinner, each used to set
 * and clear `document.body.style.overflow` on its own. Whichever cleared last
 * won, and the spinner (which saved the value underneath it, already "hidden"
 * from the dialog) restored that "hidden" after the dialog had closed, leaving
 * the page permanently unscrollable (FEDEV-614).
 *
 * Counting the locks fixes that: scroll is hidden while at least one holder is
 * active, and only restored when the last one lets go, whatever order they
 * release in. Call it when an overlay opens and invoke the returned function
 * when it closes; the returned function is safe to call more than once.
 */
let lockCount = 0

export function lockBodyScroll(): () => void {
  lockCount += 1
  if (lockCount === 1) {
    document.body.style.overflow = 'hidden'
  }

  let released = false
  return () => {
    if (released) {
      return
    }
    released = true
    lockCount = Math.max(0, lockCount - 1)
    if (lockCount === 0) {
      document.body.style.overflow = ''
    }
  }
}
